import { render, staticRenderFns } from "./TeamSelector.vue?vue&type=template&id=35bad844&scoped=true&"
import script from "./TeamSelector.vue?vue&type=script&lang=js&"
export * from "./TeamSelector.vue?vue&type=script&lang=js&"
import style0 from "./TeamSelector.vue?vue&type=style&index=0&id=35bad844&lang=scss&scoped=true&"
import style1 from "./TeamSelector.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bad844",
  null
  
)

export default component.exports